import { ActuationStudy, SearchItem, Section } from '../../../types';
import { STUDY_ATTRIBUTE_TO_SEARCH_ID } from '../../../constants/document';

const buildReferenceIds = (sectionReferenceIds: string[]): string[] => {
  return sectionReferenceIds.map((id) => (id.length > 1 ? id : `p${id}`));
};

export const buildSearchItems = (
  actuationStudy: ActuationStudy,
): SearchItem[] => {
  const searchItems = Object.keys(STUDY_ATTRIBUTE_TO_SEARCH_ID).map((key) => {
    const searchId = STUDY_ATTRIBUTE_TO_SEARCH_ID[key];
    const studyBlock = actuationStudy[key] as Section<string[]>;

    return {
      searchId,
      sections: studyBlock?.data.sectionReferenceIds
        ? buildReferenceIds(studyBlock?.data.sectionReferenceIds)
        : [],
    };
  });

  return searchItems;
};
